import {
  PLATFORM_RULES,
  MANAGE_OWN_REQUIRED_ACTIONS,
  PERMISSION_ACTIONS_RELATIONS,
  PLATFORM_MODULES_PERMISSIONS,
  PLATFORM_MODULE_ADMIN_GROUP_ID,
  PLATFORM_MODULE_ADMIN_GROUP_IDS,
  PLATFORM_MODULE_SUPER_ADMIN_GROUP_ID,
} from '@thinknet-gmbh/platform-common';

import { usePermissionContext } from 'src/contexts';

export const usePermissionCheck = (permission?: string | string[]) => {
  const { accountId, permissionGroupId, permissions } = usePermissionContext();

  const checkIfHadPermission = (permission?: string) =>
    permissions.find(item => item.permission === permission);

  const checkRule = (action: string, manageOwnCheck?: (accountId: string) => boolean) => {
    const actions = PERMISSION_ACTIONS_RELATIONS[action];

    if (!permission) {
      return true;
    }

    if (Array.isArray(permission)) {
      return permission.some(checkIfHadPermission);
    }

    const authorizedPermissions = PLATFORM_MODULES_PERMISSIONS.PLAN_WERK_MODULE;

    if (!authorizedPermissions.includes(permission) || !permissions.length) {
      return false;
    }

    const { rule } = permissions.find((doc: any) => permission === doc.permission) || {};

    if (!rule || !actions.includes(rule)) {
      return false;
    }

    if (rule === PLATFORM_RULES.manageOwn && MANAGE_OWN_REQUIRED_ACTIONS.includes(action)) {
      // manage own rule requires manage own check
      if (!manageOwnCheck) {
        return false;
      }

      if (!manageOwnCheck(accountId)) {
        return false;
      }
    }

    return true;
  };

  return {
    checkRule,
    checkIfHadPermission,
    currentPermissions: permissions,
    currentPermissionGroupId: permissionGroupId,
    checkIfGroupIsAdminGroup: (groupId: string) =>
      PLATFORM_MODULE_ADMIN_GROUP_IDS.includes(groupId),
    isAdmin: permissionGroupId === PLATFORM_MODULE_ADMIN_GROUP_ID,
    isSuperAdmin: permissionGroupId === PLATFORM_MODULE_SUPER_ADMIN_GROUP_ID,
  };
};
